import React from "react";
import "./Dropdown.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { getText, CheckValue } from "../../../services/CommonFunction";
import { imageError } from "../../../services/subscriberService";
import PropTypes from "prop-types";
import { SVG, selectIcon } from "../selector";

export const DropdownList = (props) => {
  const { optionsList, depend, selectedText } = props;
  const list = optionsList.length ? (
    optionsList.map((option, index) => {
      const cond =
        selectedText instanceof Array
          ? selectedText.some((res) => res.value === option.value)
          : selectedText.value ===
            (option.value || option[option.keyValue || "id"]);
      let select = option.child && option.child.length ? true : false;
      const childOption =
        option.child && option.child.length
          ? option.child.map((el, index1) => {
              const cond1 =
                selectedText instanceof Array
                  ? selectedText.some((res) => {
                      return res.value === el.value;
                    })
                  : selectedText.value === el.value;
              if (select) {
                select = cond1;
              }
              return (
                <List
                  key={index1}
                  option={el}
                  index={index1}
                  cond={cond1}
                  {...props}
                />
              );
            })
          : null;
      return (
        <React.Fragment key={index}>
          <List
            option={option}
            index={index}
            cond={cond || select}
            {...props}
          />
          {childOption}
        </React.Fragment>
      );
    })
  ) : (
    <li className="noItem">{getText(depend)}</li>
  );
  return list;
};

const List = (props) => {
  const { option, index, id, handleOptionClick, multiple, showImage, cond } =
    props;
  return (
    <React.Fragment>
      <li
        className={`custom-select-option${cond ? " selected" : ""}${
          CheckValue(option.parent) && !option.child.length ? " child" : ""
        }`}
        value={option.value}
        key={index}
        meta-id={id}
        onClick={() => handleOptionClick(option, cond ? false : true)}
      >
        {multiple && <span meta-id={id} className="checkmarks"></span>}
        {/* {showImage && <Images meta_id = {id} clas="listImage" src={option.thumb} alt={option.name} />} */}
        {showImage && (
          <img
            className={`listImage${option.icon ? " icon" : ""}`}
            meta-id={id}
            src={option.thumb || option.icon}
            alt={option.name || option.label}
            onError={imageError.bind(this)}
          />
        )}
        {!multiple && cond && <FontAwesomeIcon meta-id={id} icon={faCheck} />}
        {option.name || option.label}
        {option.isFeature ? (
          <SVG
            className={`feature_icon active`}
            src={selectIcon("feature_icon")}
          />
        ) : null}
      </li>
    </React.Fragment>
  );
};

DropdownList.propTypes = {
  optionsList: PropTypes.array.isRequired,
  selectedText: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  depend: PropTypes.string.isRequired,
  handleOptionClick: PropTypes.func.isRequired,
  showImage: PropTypes.bool.isRequired,
  multiple: PropTypes.bool.isRequired,
};

DropdownList.defaultProps = {
  optionsList: [],
  selectedText: [],
  id: "list",
  depend: "no-item",
  handleOptionClick: () => {},
  showImage: false,
  multiple: false,
};

export const Dropdown = (props) => {
  const { showOptionList, position } = props;
  const items = DropdownList({ ...props });
  // const items = DropdownList(optionsList,selectedText,id,handleOptionClick,showImage)
  return (
    <React.Fragment>
      {showOptionList && (
        <ul
          id={props.id}
          className={"select-options " + (position || "bottom")}
          style={props.style}
        >
          {items}
        </ul>
      )}
    </React.Fragment>
  );
};

export const MultipleDropdown = (props) => {
  const { showOptionList } = props;

  const list = DropdownList({ ...props, multiple: true });
  // const list = DropdownList(optionsList,selectedText,id,handleOptionClick,showImage,true)
  return (
    <React.Fragment>
      {showOptionList && (
        <ul
          id={props.id}
          className="multipleDropdown select-options"
          style={props.style}
        >
          {list}
        </ul>
      )}
    </React.Fragment>
  );
};

// export const FilterDropdowns = (props) => {
//     const {keyName, title} = props;
//     const optionList = getOptionList(keyName);
//     const handleOptionClick = (data) => {
//         if(!Object.keys(data).length) {
//             return;
//         }
//         filterService.sendFilterMessage({...data,keyName:keyName});
//     }
//     const items = DropdownList({...props,optionList:optionList,id:UniqueID(),handleOptionClick:handleOptionClick,showImage:true})
//     // const items = DropdownList(optionList,selectedText,UniqueID(),handleOptionClick,true)
//     return (
//         <ModalB>
//             <ModalHeader title={title} style={{textAlign:'center'}} cross={true}/>
//             <ModalBody style={{padding:'0px'}}>
//                 <ul className="filterPopup select-options" style={props.style}>
//                     {items}
//                 </ul>
//             </ModalBody>
//         </ModalB>
//     )
// }
